<template>
 <form ref="formExport" :action='action' method="post" target="_blank" enctype="application/json">
     <input ref="params" type="hidden" name="Items" v-model="paramData"/>
     <input type="hidden" name="pageNo" value="0"/>
     <input type="hidden" name="pageSize" value="0"/>
     <input type="hidden" name="sortName" value="0"/>
     <input type="hidden" name="sortOrder" value="0"/>
 </form>
</template>
  

<script>
export default {
  props: ["params", "action"],
  data() {
    return { ps: 18, pn: 1 };
  },
  computed:{
    paramData(){
      return this.params
    }
  },
  methods: {
    exportToExcel(p){
      if (p) this.$refs.params.value = "dddd"
//alert(this.$refs.params.value)
      this.$refs.formExport.submit()
    }
  }
};
//isFirst, isPre, isNext, isLast, isAdd, isExp, pageNo, pageCount, pageSize, rowCount
</script>